import React from 'react'

import { Login as OrgLogin } from '../../organisms'
import { Layout } from '../../Layout'

export const Login = () => {
  return (
    <Layout disableTermSelectbox={true}>
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          backgroundImage: 'url(/assets/hero.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0, right: 0, bottom: 0, left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.62)',
          }}
        />
        <div style={{ position: 'relative', zIndex: 1, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <OrgLogin />
        </div>
      </div>
    </Layout>
  )
}
